<template>
  <div>
    <b-modal
      id="household-modal"
      size="lg"
      title="Add/Edit HouseHold Member Information"
      hide-footer
    >
      <div v-show="show"
           class="alert alert-danger alert-dismissible fade show"
           role="alert">
                        <span v-for="(err, index) in validation_errors" :key="index">
                          {{ err[0] }} <br/>
                        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="full_name" class="col-form-label col-form-label-sm"
              >Full Name <span class="c-required">*</span></label
            >
            <input type="text" v-model="household.full_name" v-validate="{ required: true, regex: /^[a-zA-Z\.\s]*$/ }"
                    id="full_name" name="full_name"
                    class="form-control form-control-sm"
                    placeholder="Household Member full Name"
            />
            <div class="invalid-feedback">
              Please Provide Full Name
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="family_relation">Family Relation <span class="c-required">*</span></label>
            <select
              v-model="household.c_family_relation_id"
              v-validate="'required'"
              id="family_relation"
              name="family_relation"
              class="form-control form-control-sm"
              @change="isHHChk(household.c_family_relation_id)"
            >
              <option selected disabled :value="''"
                >Select Family Relation</option
              >
              <option
                v-for="(family_relation, index) in family_relations"
                :key="index"
                :value="family_relation.id"
                >{{ family_relation.id }} : {{ family_relation.desc }}</option
              >
            </select>
            <div class="invalid-feedback">
              Please select Family Relation.
            </div>
          </div>
        </div>

        <div class="form-row mt-1">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="gender" class="col-form-label col-form-label-sm"
              >Gender <span class="c-required">*</span></label
            >
            <select
              v-model="household.c_gender_id"
              v-validate="'required'"
              id="gender" name="gender"
              class="form-control form-control-sm"
            >
              <option selected disabled :value="''">Select Gender</option>
              <option
                v-for="(gender, index) in genders"
                :key="index"
                :value="gender.id"
                >{{ gender.id }} : {{ gender.desc }}</option
              >
            </select>
            <div class="invalid-feedback">
              Please select a gender.
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="age" class="col-form-label col-form-label-sm"
              >Age <span class="c-required">*</span></label
            >
            <input
              type="number"
              v-model="household.age"
              v-validate="'required|min:1|max:2'"
              name="age" id="age"
              :disabled="this.hhh"
              placeholder="Age"
              class="form-control form-control-sm"
            />
            <div class="invalid-feedback">Please Provide Person Age</div>
          </div>
        </div>

        <div class="form-row mt-1">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="education">Education <span class="c-required">*</span></label>
            <select
              v-model="household.c_education_id"
              v-validate="'required'"
              name="education" id="education"
              class="form-control form-control-sm"
            >
              <option selected disabled :value="''">Select Education</option>
              <option
                v-for="(education, index) in educations"
                :key="index"
                :value="education.id"
                >{{ education.id }} : {{ education.desc }}</option
              >
            </select>
            <div class="invalid-feedback">
              Please select Education.
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="marital_status" class="col-form-label col-form-label-sm"
              >Marital Status <span class="c-required">*</span></label
            >
            <select v-model="household.c_marital_status_id"
                    v-validate="'required'" id="marital_status" name="marital_status"
              class="form-control form-control-sm"
            >
              <option selected disabled :value="''">Select a status</option>
              <option
                v-for="(marital_status, index) in marital_statuses"
                :key="index"
                :value="marital_status.id"
                >{{ marital_status.id }} : {{ marital_status.desc }}</option
              >
            </select>
            <div class="invalid-feedback">
              Please select maritial status.
            </div>
          </div>
        </div>

        <div class="form-row mt-1">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="occupation" class="col-form-label col-form-label-sm"
              >Main Occupation <span class="c-required">*</span></label
            >
            <select
              v-model="household.c_occupation_id"
              v-validate="'required'"
              id="occupation" name="occupation"
              class="form-control form-control-sm"
            >
              <option selected disabled :value="''">Select Tree Type</option>
              <option
                v-for="occupation in occupations"
                v-bind:value="occupation.id"
                :key="occupation.id"
                >{{ occupation.id }} : {{ occupation.desc }}</option
              >
            </select>
            <div class="invalid-feedback">
              Please Select Valid Occupation
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="sec_occupations">Secondary Occupations</label>
            <multiselect
              v-model="household.sec_occupations"
              :multiple="true"
              :clear-on-select="false"
              :preserve-search="true"
              label="desc"
              track-by="id"
              :preselect-first="null"
              :options="occupations"
              id="sec_occupations"
              placeholder="Select Occupations"
            >
            </multiselect>
          </div>
        </div>

        <div class="form-row mt-1">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="family_income"> Yearly Income</label>
            <input type="number"
              v-model="household.yearly_income"
              id="family_income" name="family_income"
              class="form-control form-control-sm"
              placeholder="Yearly Income"
            />
            <div class="invalid-feedback">
              Please enter yearly income.
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="is_household_head">Are you Household Head? <span class="c-required">*</span></label>
            <select
              v-model="household.is_household_head"
              v-validate="'required'"
              id="is_household_head" name="is_household_head"
              class="form-control form-control-sm"
            >
              <option selected value="0">No</option>
              <option value="1">Yes</option>
            </select>
            <div class="invalid-feedback">
              Please enter yes/no
            </div>
          </div>
        </div>
        <div class="form-row mt-1">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="is_disable">Is Disabled? <span class="c-required">*</span></label>
            <select
              v-model="household.is_disable"
              v-validate="'required'"
              id="is_disable" name="is_disable"
              class="form-control form-control-sm"
            >
              <option selected value="0">No</option>
              <option value="1">Yes</option>
            </select>
            <div class="invalid-feedback">
              Please enter yes/no
            </div>
          </div>
        </div>

        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button
              variant="warning"
              v-if="this.btn_edit"
              class="form-control-sm mr-2"
              @click.prevent="update"
            >Update</b-button
            >
            <b-button
              variant="success"
              v-if="!this.btn_edit"
              class="form-control-sm mr-2"
              @click.prevent="save"
            >Add</b-button
            >
            <b-button
              variant="danger"
              class="form-control-sm"
              @click="$bvModal.hide('household-modal')"
            >
              Cancel
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

export default {
  components: { Datepicker, Multiselect },
  props: ["household", 'btn_edit'],

  data() {
    return {
      genders: [],
      occupations: [],
      marital_statuses: [],
      educations: [],
      family_relations: [],
      households: [],
      cclShow: true,
      validation_errors: {},
      landChk: false,
      hhh: false,
      show: false,
    };
  },

  mounted() {
    this.household.ses_id = this.$route.params.ses_id;
    this.getCodes();
  },
  methods: {
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.household.ses_id = this.$route.params.ses_id;
          http
            .post("api/ses/households", this.household)
            .then(response => {
              if (!response.data.error) {
                this.$emit("resetForm");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonHhold");
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },

    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .put("api/ses/households/" + this.household.id, this.household)
            .then(response => {
              if (!response.data.error) {
                this.$bvModal.hide("household-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getPersonHhold");
              } else {
                this.$bvToast.toast("Update Failed", {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
              this.$bvToast.toast("Update Failed", {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            });
        }
      });
    },

    getCodes() {
      http.get("api/ses/household/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.genders = data.genders;
          this.occupations = data.occupations;
          this.marital_statuses = data.marital_statuses;
          this.educations = data.educations;
          this.family_relations = data.family_relations;
        }
      });
    },

    isHHChk(relationId) {
      var rel = relationId - 1;
      this.household.c_gender_id = this.family_relations[rel].c_gender_id;
      if (relationId == 1 && this.btn_edit != true) {
        this.$emit("getCensusInfo", this.$route.params.ses_id);
      }
    },

    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },

};
</script>
<style>
  .c-required{
    color: red;
  }
</style>